module.exports = __webpack_public_path__ + "static/media/123_1579693507773.4bd5200e.png";